import { Notify } from 'quasar';

type GenericOpts = {[key: string]: unknown};
interface SnackbarAction extends GenericOpts {
  label?: string;
  handler: () => void;
}

function showSuccessSnackBar(message: string, actions: SnackbarAction[] = [], timeout = 2000, closeButton = true, onDismissHandler?: () => void) {

  actions = actions || [];
  if (closeButton) {
    actions.push({
      handler: () => closeNotification(),
      icon: 'fa-regular fa-xmark',
      class: 'io-mfe-ig-icon-button-medium',
      round: true
    });
  }

  const closeHandle = Notify.create({
    onDismiss: () => {
      onDismissHandler && onDismissHandler();
    },
    message,
    actions,
    icon: 'fa-regular fa-circle-check',
    color: 'iosnackbarsuccess',
    textColor: 'iosnackbarsuccess',
    iconColor: 'iosnackbariconsuccess',
    position: 'bottom-right',
    classes: 'io-mfe-ig-snackbar io-mfe-ig-snackbar-success',
    multiLine: false,
    timeout
  });

  function closeNotification() {
    closeHandle && closeHandle();
  }
}

function showNotificationBar(message: string) {

  Notify.create({
    message,
    icon: 'fa-regular fa-circle-check',
    color: 'iosnackbarsuccess',
    textColor: 'iosnackbarsuccess',
    iconColor: 'iosnackbariconsuccess',
    position: 'bottom-right',
    classes: 'io-mfe-ig-snackbar io-mfe-ig-snackbar-success',
    timeout: 2000
  });
}

export {SnackbarAction, showSuccessSnackBar, showNotificationBar}